<div class="panel panel-success widget-support-tickets">
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">

          <p-table #dt [value]="fileData" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="5%">#</th>-->
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="table-edit">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>

              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr *ngIf="fileData.length>0">
                <td> {{ item.month }}</td>
                <td>{{item.year}}</td>
                <td *ngIf="item.hcoName"> {{ item.hcoName }}</td>
                <td *ngIf="item.pharmacyName"> {{ item.pharmacyName }}</td>
                <td> {{ item.itemName }}</td>
                <td *ngIf="viewOnly"> {{ item.quantity }}</td>
                <td *ngIf="viewOnly"> {{ item.value }}</td>
                <td *ngIf="!viewOnly"> <input type="text" name="quantity" [(ngModel)]="item.quantity" #quantity="ngModel" class="form-control" /> </td>
                <td *ngIf="!viewOnly"> <input type="text" name="value" [(ngModel)]="item.value" #value="ngModel" class="form-control" /> </td>
                <td> {{ getStatusName(item.status) }}</td>

              </tr>
              <tr *ngIf="fileData.length==0">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>

            </ng-template>
          </p-table>

        </div>

      </div>

      <div class="panel-footer margin-left-30 margin-top-20">
        <button type="button" (click)="approve(true)" class="btn btn-cancel" *ngIf="!viewOnly">{{'app.approve' | translate}}</button>
        <button type="button" class="btn btn-save" (click)="approve(false)" *ngIf="!viewOnly">{{'app.reject' | translate}}</button>.
        <button type="button" (click)="cancel()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
      </div>

    </div>
  </div>
</div>

